import(/* webpackMode: "eager", webpackExports: ["Box"] */ "/vercel/path0/node_modules/@chakra-ui/react/dist/esm/box/box.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["Highlight"] */ "/vercel/path0/node_modules/@chakra-ui/react/dist/esm/highlight/highlight.mjs");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/@chakra-ui/react/dist/esm/list/list.mjs");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/@chakra-ui/react/dist/esm/stack/stack.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["Heading"] */ "/vercel/path0/node_modules/@chakra-ui/react/dist/esm/typography/heading.mjs");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/@chakra-ui/react/dist/esm/typography/text.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/vercel/path0/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/shared/lib/lazy-dynamic/preload-chunks.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/certificates/index.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/contactForm/index.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/features/index.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/ourCustomers/index.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/technologyPartners/index.tsx");
